import { useEffect, useState } from 'react';
import { savePref } from './prefs';

export const DESIGNS = [
  { id: 'executive', label: 'Executive Light', text: 'Chiara ed elegante, menu laterale blu notte', img: '/designs/executive.jpg' },
  { id: 'rosso', label: 'SmartInfo Rosso', text: 'Scura con accenti rossi Smart Info, menu laterale con testi', img: '/designs/rosso.jpg' },
];
export const DEFAULT_DESIGN = 'executive';
export const isDesign = (t) => DESIGNS.some((d) => d.id === t);
const KEY = 'bond_portal_theme';

export function usePortalTheme(user) {
  const saved = user?.preferences?.theme;
  const [theme, setThemeState] = useState(() => {
    if (isDesign(saved)) return saved;
    return isDesign(localStorage.getItem(KEY)) ? localStorage.getItem(KEY) : DEFAULT_DESIGN;
  });
  useEffect(() => { if (isDesign(saved)) setThemeState(saved); }, [saved]);
  useEffect(() => {
    document.documentElement.setAttribute('data-ptheme', theme);
    localStorage.setItem(KEY, theme);
  }, [theme]);
  useEffect(() => () => document.documentElement.removeAttribute('data-ptheme'), []);
  const setTheme = (t, save = true) => { setThemeState(t); if (save) savePref('theme', t); };
  return { theme, setTheme, chosen: isDesign(saved) };
}

export function useLoginTheme() {
  useEffect(() => {
    document.documentElement.setAttribute('data-ptheme', 'noir');
    return () => document.documentElement.removeAttribute('data-ptheme');
  }, []);
}

export const themeCssVar = (name) => getComputedStyle(document.documentElement).getPropertyValue(name).trim();
